export default "__VITE_ASSET__ce79ea25__"